import { Edit, Form, Input, useForm } from "@pankod/refine-antd";
import { IResourceComponentsProps, useShow } from "@pankod/refine-core";
import "react-mde/lib/styles/css/react-mde-all.css";
import { ITag } from "types/tag.interface";

export const GenreEdit: React.FC<IResourceComponentsProps> = () => {
  const { formProps, saveButtonProps, formLoading } = useForm<ITag>();

  const { queryResult } = useShow<ITag>();
  const { data, isLoading } = queryResult;
  const record: any = data?.data;

  return (
    <Edit
      saveButtonProps={saveButtonProps}
      isLoading={isLoading || formLoading}
    >
      <Form {...formProps} layout="vertical">
        <Form.Item
          label="Name"
          name="name"
          rules={[
            {
              required: true,
              message: "Name is required",
            },
          ]}
          initialValue={record?.data.name}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label="Description"
          name="description"
          rules={[
            {
              required: false,
            },
          ]}
          initialValue={record?.data.description}
        >
          <Input />
        </Form.Item>

        <div style={{ display: "flex" }}>
          <Form.Item
            label="Color"
            name="color"
            rules={[
              {
                required: false,
              },
            ]}
            style={{ width: "10%", marginRight: "40%" }}
          >
            <Input type="color" defaultValue={record?.data.color} />
          </Form.Item>
          <Form.Item
            label="BgColor"
            name="bgColor"
            rules={[
              {
                required: false,
              },
            ]}
            style={{ width: "10%" }}
          >
            <Input type="color" defaultValue={record?.data.bgColor} />
          </Form.Item>
        </div>
      </Form>
    </Edit>
  );
};
